import { gql, useQuery } from "@apollo/client";
import { blackCardProgram } from "../apollo/server";

const BLACK_CARD_PROGRAM = gql`
  ${blackCardProgram}
`;

// What Black Card offered before a super admin could change it. Shown until
// the server answers, so the page never renders empty.
export const BLACK_CARD_DEFAULTS = {
  enabled: true,
  monthlyPrice: 49.99,
  deliveryDiscountCap: 7,
  bonusPointsPerOrder: 50,
};

/** $7 for whole dollars, $49.99 otherwise. */
export function bcMoney(n) {
  const v = Number(n) || 0;
  return `$${Number.isInteger(v) ? v : v.toFixed(2)}`;
}

/**
 * The Black Card program the super admin set: on/off, the price new members
 * pay, and the perks. `loaded` is false until the server has answered, so
 * callers can hold back anything that depends on Black Card being on. A
 * server that can't answer (one from before this setting) means the defaults.
 */
export default function useBlackCardProgram() {
  const { data, error } = useQuery(BLACK_CARD_PROGRAM, { fetchPolicy: "cache-and-network" });
  const program = data?.blackCardProgram;
  return { program: program || BLACK_CARD_DEFAULTS, loaded: !!program || !!error };
}
